import React from 'react';
import ListItemAvatarBase from '@material-ui/core/ListItemAvatar';

const ListItemAvatar = ({ children, ...props }) => (
  <ListItemAvatarBase {...props}>{children}</ListItemAvatarBase>
);

export default ListItemAvatar;
